<template>
  <ul class="nav nav-mobile-menu">
    <li :class="{ active: isActive(billingHref) }">
      <a 
        :href="billingHref" class="dropdown-toggle" 
        data-toggle="dropdown"
        data-tour="nav_billing"
      >
        <i class="material-icons">credit_card</i>
        <p>Billing</p></a
      >
    </li>
    <li :class="{ active: isActive(logoutHref) }">
      <a
        :href="logoutHref"
        class="dropdown-toggle"
        data-toggle="dropdown"
        data-tour="nav_logout"
        @click="logoff"
      >
        <i class="material-icons">arrow_right_alt</i>
        <p>Logout</p></a
      >
    </li>
  </ul>
</template>
<script>
import { logout } from "../../../../utils/auth0";
export default {
  data() {
    return {
      billingHref: "#/billing",
      logoutHref: "#"
    };
  },
  methods: {
    logoff() {
      logout();
    },
    isActive(link) {
      if (link.startsWith("#")) {
        link = link.substring(1);
      }

      if (this.$route && this.$route.path) {
        return this.$route.path === link;
      }
      return false;
    }
  }
};
</script>
